import { format, isValid, parse, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

export function formatRdoNumber(sequenceNumber: number, revision: number) {
	const base = `Relatório de Obra nº ${sequenceNumber}`;
	return revision > 1 ? `${base} · rev. ${revision}` : base;
}

export function formatRdoRevision(revision: number) {
	return revision > 1 ? `Rev. ${revision}` : "Original";
}

export function parseReportDate(value: string): Date | undefined {
	const parsed = parse(value, "yyyy-MM-dd", new Date());
	return isValid(parsed) ? parsed : undefined;
}

export function formatRdoDate(value: string) {
	const date = parseReportDate(value);
	return date ? format(date, "dd/MM/yyyy") : value;
}

export function formatRdoDateLong(value: string) {
	const date = parseReportDate(value);
	return date
		? format(date, "EEEE, d 'de' MMMM 'de' yyyy", { locale: ptBR })
		: value;
}

export function formatRdoTime(value: string | undefined) {
	if (!value) return "";
	const date = parseISO(value);
	return isValid(date) ? format(date, "HH:mm") : "";
}

export function formatRdoDateTime(value: string | undefined) {
	if (!value) return "";
	const date = parseISO(value);
	return isValid(date) ? format(date, "dd/MM/yyyy HH:mm") : "";
}

export function formatRdoIssuedAt(value: string | undefined) {
	if (!value) return "";
	const date = parseISO(value);
	return isValid(date) ? format(date, "dd/MM/yyyy 'às' HH:mm:ss") : "";
}

export function combineReportDateTime(
	reportDate: string,
	time: string,
): string | undefined {
	const day = parseReportDate(reportDate);
	const match = time.match(/^(\d{2}):(\d{2})$/);
	if (!day || !match) return undefined;
	const combined = new Date(
		day.getFullYear(),
		day.getMonth(),
		day.getDate(),
		Number(match[1]),
		Number(match[2]),
	);
	return combined.toISOString();
}

export function formatPercent(value: number) {
	return `${value.toLocaleString("pt-BR", { maximumFractionDigits: 1 })}%`;
}

export function rdoPdfFilename(rdo: {
	sequenceNumber: number;
	reportDate: string;
	revision: number;
}) {
	return `RDO-${rdo.sequenceNumber}-${rdo.reportDate}-rev${rdo.revision}.pdf`;
}
